// src/components/common/CustomDataGrid.jsx

import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, useTheme, Typography } from "@mui/material";

const CustomDataGrid = ({
  rows,
  columns,
  loading = false,
  height = 600,
  getRowId,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height,
        width: "100%",
        mt: 3,
        borderRadius: "10px",
        border: `1px solid ${theme.palette.divider}`,
        overflow: "hidden",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        getRowId={getRowId}
        pageSizeOptions={[5, 10, 20, 50]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } },
        }}
        checkboxSelection
        disableRowSelectionOnClick
        density="comfortable"
        slots={{
          noRowsOverlay: () => (
            // <Typography sx={{ p: 2 }}>No data available</Typography>
            <Box 
              display="flex" 
              justifyContent="center" 
              alignItems="center" 
              minHeight="200px" // Optional: gives it space to be "middle" of a area
            >
              <Typography sx={{ p: 2 }}>No data available</Typography>
            </Box>
          ),
        }}
        sx={{
          border: "none",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.paper,
            fontWeight: "bold",
            borderBottom: `1px solid ${theme.palette.divider}`,
          },
          "& .MuiDataGrid-cell": {
            borderBottom: `1px solid ${theme.palette.divider}`,
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: `1px solid ${theme.palette.divider}`,
          },
          "& .MuiCheckbox-root": {
            color: theme.palette.primary.main,
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: theme.palette.action.hover,
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
        }}
      />
    </Box>
  );
};

export default CustomDataGrid;
